export async function getAddressFromCoords(lat: number, lon: number): Promise<string | null> {
    const baseUrl = 'https://geocode-maps.yandex.ru/1.x/';
    const format = 'json';
    const coords = `${lon},${lat}`; // Сначала долгота, потом широта, как требует Яндекс
    
    const url = `${baseUrl}?apikey=a8e2e142-a157-4779-9d8b-a1e54e94a96e&format=${format}&geocode=${coords}`;

    try {
        const response = await fetch(url);
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();

        const geoObjectCollection = data?.response?.GeoObjectCollection;
        const firstGeoObject = geoObjectCollection?.featureMember?.[0]?.GeoObject;

        if (firstGeoObject) {
            const address = firstGeoObject.metaDataProperty.GeocoderMetaData.text;
            return address;
        } else {
            console.warn('Адрес не найден по этим координатам.');
            return null;
        }

    } catch (error) {
        console.error('Ошибка при запросе к Яндекс Геокодеру:', error);
        return null;
    }
}

type GeoObjectComponent = {
    kind: string;
    name: string;
};

export async function getFormattedAddress(
    lat: number,
    lon: number,
): Promise<string | null> {
    const baseUrl = 'https://geocode-maps.yandex.ru/1.x/';
    const format = 'json';
    const coords = `${lon},${lat}`;
    const url = `${baseUrl}?apikey=a8e2e142-a157-4779-9d8b-a1e54e94a96e&format=${format}&geocode=${coords}`;

    try {
        const response = await fetch(url);
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();

        const firstGeoObject = data?.response?.GeoObjectCollection?.featureMember?.[0]?.GeoObject;

        if (!firstGeoObject) {
            console.warn('Адрес не найден по этим координатам.');
            return null;
        }

        const components: GeoObjectComponent[] =
            firstGeoObject.metaDataProperty?.GeocoderMetaData?.Address?.Components ?? [];

        // Собираем по нужным компонентам:
        const country = components.find(c => c.kind === 'country')?.name ?? '';
        const locality = components.find(c => c.kind === 'locality')?.name
            ?? components.find(c => c.kind === 'province')?.name ?? '';
        const district = components.find(c => c.kind === 'district')?.name ?? '';
        const microdistrict = components.find(c => c.kind === 'area')?.name
            ?? components.find(c => c.kind === 'subdistrict')?.name
            ?? components.find(c => c.kind === 'other')?.name
            ?? ''; // Можно расширить, если понадобится
        const street = components.find(c => c.kind === 'street')?.name ?? '';
        const house = components.find(c => c.kind === 'house')?.name ?? '';

        const parts = [
            country,
            locality,
            district,
            microdistrict,
            street,
            house
        ].filter(Boolean); // Убираем пустые элементы

        const formattedAddress = parts.join(', ');

        return formattedAddress;

    } catch (error) {
        console.error('Ошибка при запросе к Яндекс Геокодеру:', error);
        return null;
    }
}
